import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { isInsideTelegram } from '@/telegramWebApp'
import { guardRedirect } from './guard'
import { routes } from './routes'
import { rememberScroll, scrollFor } from './scroll'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: scrollFor,
  routes,
})

// Every route other than the public ones (`/welcome`) and /auth requires a signed-in session. `idle` means sign-in hasn't
// been attempted yet (app just booted, or a mid-session 401 called auth.reset()) -- attempt it here, once, before
// deciding whether to let the navigation through. The decision itself is `guard.ts::guardRedirect`.
router.beforeEach(async (to, from) => {
  rememberScroll(from, window.scrollY)
  const auth = useAuthStore()

  if (auth.status === 'idle') {
    await auth.signIn()
  }

  return guardRedirect({
    status: auth.status,
    isAdmin: auth.isAdmin,
    insideTelegram: isInsideTelegram(),
    to: {
      name: to.name,
      fullPath: to.fullPath,
      redirect: to.query.redirect,
      isPublic: to.meta.public === true,
      requiresAdmin: to.meta.requiresAdmin === true,
    },
  })
})

export default router
